'use strict';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import Footer from './Footer';

const Presets = ({ onSelectPreset }) => {
  // preset data
  const presets = {
    'Green': {
      className: 'green',
      colors: {
        leftBarColor: '#242E14',
      },
    },

    'Default': {
      className: 'default',
      colors: {
        leftBarColor: '#1e1e1e',
      },
    },

    'Orange': {
      className: 'orange',
      colors: {
        leftBarColor: '#E99D69',
      },
    },

    'Red': {
      className: 'red',
      colors: {
        leftBarColor: '#58241C',
      },
    },

    'Neutral': {
      className: 'neutral',
      colors: {
        leftBarColor: '#948474',
      },
    },

    'Purple': {
      className: 'purple',
      colors: {
        leftBarColor: '#401B48',
      },
    },

    'Brown': {
      className: 'brown',
      colors: {
        leftBarColor: '#362C23',
      },
    },

    'Pink': {
      className: 'pink',
      colors: {
        leftBarColor: '#CF9489',
      },
    },
  };

  // track selected colors
  const [selectedColors, setSelectedColors] = useState({
    leftBarColor: '#1e1e1e', 
  });

  // handle preset change
  const changePreset = (presetKey) => {
    const preset = presets[presetKey];
    if (preset) {
      onSelectPreset(preset.className, preset.colors);
      setSelectedColors(preset.colors);
    }
  };

  return (
    <div>
    <main>
      <section>
        <Link to="/"><img className="back-icon" src="img/back.png" alt="back icon"></img></Link>
        <div className='preset-family'>
          <h1 className="title">Color Presets</h1>
          <div className='container'>
          <div className='preset-container' style={{ backgroundColor: selectedColors.leftBarColor }}>
          <button className="preset" onClick={() => changePreset('Default')}>
              <img src="img/desk.avif" alt="A brown desk with a black laptop, phone, and lamp"></img>
              <p>Default</p>
            </button>
          <button className="preset" onClick={() => changePreset('Green')}>
                <img src="img/rainyday.jpg" alt="Rain droplets rolling off of a roof" />
                <p>Green</p>
              </button>
            <button className="preset" onClick={() => changePreset('Orange')}>
              <img src='img/beach.jpg' alt='A beach with a sunrise'></img>
              <p>Orange</p>
            </button>
            <button className="preset" onClick={() => changePreset('Red')}>
              <img src='img/camp.jpg' alt='A campfire at night'></img>
              <p>Red</p>
            </button>
            <button className="preset" onClick={() => changePreset('Neutral')}>
              <img src='img/cleangirl.jpg' alt='A sidetable with lamp and tissues'></img>
              <p>Neutral</p>
            </button>
            <button className="preset" onClick={() => changePreset('Purple')}>
              <img src='img/jazzbar.jpg' alt='A closeup of brass instruments'></img>
              <p>Purple</p>
            </button>
            <button className="preset" onClick={() => changePreset('Brown')}>
              <img src='img/academia.jpg' alt='A bookshelf with a ladder in front of it'></img>
              <p>Brown</p>
            </button>
            <button className="preset" onClick={() => changePreset("Pink")}>
              <img src='img/valentines.jpg' alt="Pink hearts"></img>
              <p>Pink</p>
            </button>
          </div>
        </div>
        </div>
      </section>
    </main>
    <Footer />
    </div>
  );
};

export default Presets;